export default "__VITE_ASSET__Btdd9aPO__"